import React, { useRef } from "react";
import "./contact.css";
import { MdMarkEmailRead } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_x5bikt8",
        "template_pukcz2v",
        form.current,
        "snfEo6j_1rrnA3lKy"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Us</h2>
      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdMarkEmailRead className="contact_option_icon" />
            <h4>Email</h4>
            <h5>pranavtripathi79@gmail.com</h5>
            <a href="mailto:pranavtripathi79@gmail.com">Send a message...</a>
          </article>

          <article className="contact_option">
            <IoLogoWhatsapp className="contact_option_icon" />
            <h4>WhatsApp</h4>
            <h5>+91-1234567890</h5>
            <a
              href="https://api.whatsapp.com/send?phone=918953955055"
              target="_blank"
              rel="noopener noreferrer"
            >
              Send a message...
            </a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            id="name"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            id="email"
            required
          />
          <textarea
            name="message"
            id="message"
            rows="8"
            placeholder="Your Message"
            required
          ></textarea>

          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
